import { ChangeEvent } from "react";
import { TRecall } from "src/types/types";
import { StateCreator } from "zustand";

export interface RecallSlice {
  isRecall: TRecall;
  stars: number;
  ratingItems: number[];
  setRatingItems: (items: number[]) => void;
  ratingType: "bad" | "good" | "";
  setRecall: (recall: TRecall) => void;
  setStars: (stars: number) => void;
  changeStars: (e: ChangeEvent<HTMLFormElement>) => void;
}

export const createRecallSlice: StateCreator<RecallSlice> = set => ({
  isRecall: "disabled",
  stars: 0,
  ratingItems: [],
  setRatingItems: ratingItems => set(() => ({ ratingItems })),
  ratingType: "",
  setRecall: isRecall => set(() => ({ isRecall })),
  setStars: stars => set(() => ({ stars })),
  changeStars: e =>
    set(state => ({
      stars: e.target.value,
      ratingItems:
        (state.stars < 5 && e.target.value == 5) ||
        (state.stars > 4 && e.target.value < 5)
          ? []
          : state.ratingItems,
      ratingType: e.target.value < 5 ? "bad" : "good",
    })),
});
